import { Grid, Typography } from "@mui/material";
import { ZegoUIKitPrebuilt } from "@zegocloud/zego-uikit-prebuilt";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../../components/CustomButton";
import CustomCheckbox from "../../../../components/CustomCheckbox";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../../components/CustomTextField";
import { getPetMedicalHistory } from "../../../../redux/reducers/medicalHistorySlice";
import { getPetsCompliantSummary } from "../../../../redux/reducers/petSlice";
import {
  assignBundleToAppointment,
  getAllTreatmentBundlesByPetId,
} from "../../../../redux/reducers/planSlice";
import { AppColors } from "../../../../util/AppColors";

const Overview = ({
  getPetData,
  isVideoCallEnabled,
  setVideoCallEnabled,
  setAllergyModOpen,
  appointment,
}) => {
  const dispatch = useDispatch();
  const [preventiveList, setPreventiveList] = useState([]);
  const [medicationList, setMedicationList] = useState([]);
  const [selectedBundle, setSelectedBundle] = useState(null);
  const [bundleSearchValue, setBundleSearchValue] = useState("");
  const [bundleModVsble, setBundleModVsble] = useState(false);
  const reqDet = useSelector((state) => state?.pet?.complaintSummary?.data);
  const petDetails = useSelector((state) => state?.pet?.petDetails);
  const medHisList = useSelector(
    (state) => state?.medicalHistory?.medicalHistoryByPet
  );
  const { petTreatmentBundles } = useSelector((state) => state?.plan);
  const apntId = appointment?.appoinment?.appointmentId;
  const appDet = reqDet?.appointment;
  const petData = apntId ? reqDet?.pet : petDetails;
  const apnt = appointment?.appoinment;

  useEffect(() => {
    if (!getPetData?.[0]?.petId && !apnt?.petId) return;
    dispatch(getPetMedicalHistory(getPetData?.[0]?.petId ?? apnt?.petId));
  }, [getPetData?.[0]?.petId || apnt?.petId]);

  useEffect(() => {
    getRequiredList();
  }, [medHisList]);

  const getRequiredList = () => {
    const prevList = [];
    const medList = [];
    medHisList?.map((ml) => {
      if (ml?.prevetive?.length > 0) {
        ml?.prevetive?.filter((pre) => {
          if (pre?.status === "Completed") {
            if (!prevList?.find((pr) => pr?.status === "Completed")) {
              prevList?.push({ ...pre, status: pre?.status });
            }
          }
          if (pre?.status === "Pending") {
            if (!prevList?.find((pr) => pr?.status === "Pending")) {
              prevList?.push({ ...pre, status: pre?.status });
            }
          }
          if (pre?.status === "Overdue") {
            if (!prevList?.find((pr) => pr?.status === "Overdue")) {
              prevList?.push({ ...pre, status: pre?.status });
            }
          }
        });
      }
      if (ml?.prescription?.length > 0) {
        ml?.prescription?.[0]?.prescriptionDetails?.filter((pd) => {
          if (medList?.length !== 3) {
            medList?.push({ ...pd, date: ml?.prescription?.[0]?.createdDate });
          }
        });
      }
    });
    setPreventiveList(prevList);
    setMedicationList(medList);
  };

  const myMeeting = async (element) => {
    const roomID = appDet?.videoCallId;
    const userID = appDet?.doctorId?.toString();
    const userName = appDet?.doctorName;
    const token = "faeb80d20908d605f3acbf67f8c25191";
    const kitToken = ZegoUIKitPrebuilt.generateKitTokenForTest(
      704271205,
      token,
      roomID,
      userID,
      userName
    );

    const zp = ZegoUIKitPrebuilt.create(kitToken);
    zp.joinRoom({
      container: element,
      scenario: {
        mode: ZegoUIKitPrebuilt.GroupCall,
      },
      onLeaveRoom: async () => {
        setVideoCallEnabled(false);
        localStorage.setItem(
          "videoCallPageReloaded",
          JSON.stringify({
            state: appDet,
          })
        );
        window.location.reload();
      },
      showLeavingView: false,
      showScreenSharingButton: false,
      maxUsers: 2,
      showPreJoinView: false,
      showTextChat: false,
      showRoomDetailsButton: false,
    });
  };

  const getAppointmentSummaryImgaes = () => {
    return (
      medHisList?.find((med) => med?.appointentId === appDet?.appointmentId)
        ?.appointmentImage ?? null
    );
  };

  const handleAssignBundle = () => {
    dispatch(getAllTreatmentBundlesByPetId(petData?.petId));
    setBundleModVsble(true);
  };

  const handleBundleclose = () => {
    setSelectedBundle(null);
    setBundleModVsble(false);
    setBundleSearchValue("");
  };

  const handleAssign = () => {
    if (!selectedBundle?.bundleId || !apntId) return;
    dispatch(
      assignBundleToAppointment({
        bundleId: selectedBundle?.bundleId,
        appointmentId: apntId,
      })
    ).then((res) => {
      if (res?.payload) {
        dispatch(getPetsCompliantSummary(apntId));
        handleBundleclose();
      }
    });
  };

  return (
    <>
      {isVideoCallEnabled ? (
        <div ref={myMeeting} className="vid-cal-con" />
      ) : null}

      <Grid container className="mv3 back-white pb100">
        {apntId ? (
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="flex-row-ali-cen mb20">
              <div className="w80Per">
                <div className="blue-box-examD">
                  <div className="flex-row">
                    <div className="w40Per">
                      <Typography className="fs16 blue-color font-bold">
                        Appointment Details
                      </Typography>
                      <Typography className="card-black1 fs14 txt-semi-bold">
                        Meeting Dr. {appDet?.doctorName}
                      </Typography>
                    </div>
                    <div className="w30Per">
                      <div className="flex-row-ali-cen">
                        <img
                          src={require("../../../../assets/images/png/calen.png")}
                          className="img-wh15"
                        />
                        <Typography className="gray25 fs14 font-bold ml5">
                          {moment(appDet?.appointmentDate).format(
                            "DD MMM YYYY"
                          )}
                        </Typography>
                      </div>
                      <div className="flex-row-ali-cen">
                        <img
                          src={require("../../../../assets/images/png/clock.png")}
                          className="img-wh15"
                        />
                        <Typography className="gray25 fs14 font-bold ml5">
                          {appDet?.appointmentStartTime ??
                            moment(
                              new Date(appDet?.appointmentdateTime)
                            ).format("HH:mm")}
                        </Typography>
                      </div>
                    </div>
                    <div className="flex1-end">
                      <div className="flex-row-ali-cen">
                        <Typography
                          className={`font-medium fs10 card-time  white-color
                                    flex-center  ${
                                      appDet?.appointmentType === "Physical"
                                        ? "card-bot-blue-back"
                                        : "virtual-bg"
                                    }`}
                        >
                          {appDet?.appointmentType === "Home"
                            ? "Home Visit"
                            : appDet?.appointmentType}
                        </Typography>

                        {/* <Typography
                          className={`font-medium fs10 ml10 card-time  white-color
                                    flex-center  gray-back3`}
                        >
                          Follow-up
                        </Typography> */}
                      </div>
                    </div>
                  </div>
                  <Typography className="light-blue fs14 txt-semi-bold">
                    {appDet?.serviceType} | {appDet?.reason}
                  </Typography>
                  <div className="gry-hor-split3 mv5" />
                  <div className="flex-row-between-align-center">
                    <div className="flex-row-ali-cen">
                      <Typography className="fs14 blue-color font-medium">
                        Last Visit:
                      </Typography>
                      <Typography className="ml5 fs14 gray26 txt-semi-bold">
                        20, May 2024
                      </Typography>
                    </div>
                    <div className="flex-row-ali-cen">
                      <Typography className="fs14 blue-color font-medium">
                        Last Visit:
                      </Typography>
                      <Typography className="ml5 fs14 gray26 txt-semi-bold">
                        20, May 2024
                      </Typography>
                    </div>
                  </div>
                </div>
              </div>
              <div className="ml10">
                {/* <div>
                  <CustomButton text="Call-in" smallBtn />
                </div> */}
                {!reqDet?.bundleId ? (
                  <div
                  // className="mt10"
                  >
                    <CustomButton
                      text="Assign Plan"
                      smallBtn
                      yellowBtn
                      onClick={handleAssignBundle}
                    />
                  </div>
                ) : null}
              </div>
            </div>
          </Grid>
        ) : null}
        {apntId && (
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="flex-row-ali-cen">
              <div className="flex-row-ali-cen ovr-head-back">
                <Typography className="txt-semi-bold fs14 balck ml10">
                  {appDet?.appointmentStatus === "completed"
                    ? "Previous Appointment:"
                    : appDet?.appointmentStatus !== "completed" &&
                      appDet?.appointmentStatus !== "cancelled"
                    ? "Upcoming Appointment:"
                    : ""}
                </Typography>
                <div className="flex-center">
                  <Typography
                    className="fs14 ml5 "
                    style={{ fontWeight: "650" }}
                  >
                    {moment(appDet?.appointmentDate).format("DD MMM YYYY")}
                  </Typography>
                </div>

                <div className="flex-center">
                  <div className="ml10 card-light-blue-back card-time">
                    <Typography className="txt-regular card-blue2 fs12">
                      {appDet?.appointmentStartTime ??
                        moment(new Date(appDet?.appointmentdateTime)).format(
                          "HH:mm"
                        )}
                    </Typography>
                  </div>
                </div>
                <Typography
                  className={`font-medium fs10 ml10 card-time  ${
                    appDet?.appointmentType === "Physical"
                      ? "card-bot-blue-back"
                      : "virtual-bg"
                  }  white-color
                flex-center`}
                >
                  {appDet?.appointmentType}
                </Typography>
              </div>
            </div>
          </Grid>
        )}

        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <div className="flex-row-ali-cen mv5">
            <div className="flex-row ovr-head-back">
              <img
                src={require("../../../../assets/images/png/allergyIcon.png")}
                alt=""
                className="img-wh20 ml10"
              />
              <Typography className="txt-semi-bold fs14 balck ml10">
                Allergies:
              </Typography>
              {(apntId || apnt?.petId) && petData?.allergies?.length > 0 ? (
                petData?.allergies?.map((al, i) => (
                  <Typography className="txt-semi-bold fs14 card-head-orange-color ml5">
                    {`${al?.allergies}${
                      i + 1 === petData?.allergies?.length ? "" : ","
                    }`}
                  </Typography>
                ))
              ) : (
                <Typography className="txt-semi-bold fs14 card-head-orange-color ml5">
                  None specified
                </Typography>
              )}
              <div className="flex1-end">
                <img
                  src={require("../../../../assets/images/png/edit-new.png")}
                  alt=""
                  className="img-wh20 ml10 cursor"
                  onClick={() => setAllergyModOpen(true)}
                />
              </div>
            </div>
          </div>
        </Grid>

        {/* {appDet?.petId === 17 ? (
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Typography className="font-bold mt20">
              Appointment Condition
            </Typography>
            <div style={{ display: "flex" }}>
              <Typography className="mt10 fs14 txt-regular blue-back-con">
                Gastrointestinal Issues - Vomiting and Lethargy
              </Typography>
            </div>
          </Grid>
        ) : null} */}

        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Typography className="font-bold mt20">
            Appointment Summary
          </Typography>
        </Grid>
        {appDet?.appointmentSummary?.length > 0 ? (
          <div>
            <Typography className="mt10 fs14 txt-regular">
              {appDet?.appointmentSummary}
            </Typography>
            {getAppointmentSummaryImgaes()?.length > 0 ? (
              <div className="flex-row-ali-cen flex-row-wrap mt20">
                {getAppointmentSummaryImgaes()?.map((img, i) => (
                  <img
                    key={img?.id + i}
                    src={img?.image}
                    alt=""
                    className="img2 br5 m5"
                  />
                ))}
              </div>
            ) : null}
          </div>
        ) : (
          <div className="no-rec h50">No records available</div>
        )}

        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Typography className="font-bold mt20">Clinical Summary</Typography>
        </Grid>
        {appDet?.clinicalSummary?.length > 0 && appDet?.petId !== 17 ? (
          <Typography className="mt10 fs14 txt-regular">
            {appDet?.clinicalSummary}
          </Typography>
        ) : (
          <div className="no-rec h50">No records available</div>
        )}
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="mt20">
          <Typography className="font-bold fs14">Preventive History</Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="mt10">
          <div className="flex-row-ali-cen">
            {(apntId || apnt?.petId === getPetData?.[0]?.petId) &&
            preventiveList?.length > 0 ? (
              preventiveList?.map((pl, i) => (
                <>
                  <div className="w30Per">
                    <div className="flex-column">
                      <Typography className="txt-semi-bold gray7 fs12 mt10">
                        {pl?.type === "vaccination"
                          ? "Vaccination"
                          : pl?.type === "fleaTreatment"
                          ? "Flea treatment"
                          : "Deworming"}
                      </Typography>
                      <Typography className="txt-semi-bold black2 fs12 mt10">
                        {pl?.name}
                      </Typography>
                      {pl?.date ? (
                        <div className="flex-row-ali-cen mt10">
                          <div className="gray-dot2" />
                          <Typography className="txt-semi-bold fs10 ml5 orange2">
                            Date: {moment(pl?.date).format("DD MMM YYYY")}
                          </Typography>
                        </div>
                      ) : null}
                    </div>
                    <Typography
                      className={`txt-semi-bold fs12 mt10 ph10pv3 br5 width-fit-con ${
                        pl?.status === "Completed"
                          ? "green2"
                          : pl?.status === "Pending"
                          ? "orange3"
                          : "red3"
                      } ${
                        pl?.status === "Completed"
                          ? "green-back2"
                          : "orange-back"
                      }`}
                    >
                      {pl?.status}
                    </Typography>
                  </div>

                  {preventiveList?.length !== i + 1 ? (
                    <div className="w5Per">
                      <div className="flex-center">
                        <div className="ver-bar-h30 h100" />
                      </div>
                    </div>
                  ) : null}
                </>
              ))
            ) : (
              <div className="no-rec h50">No records available</div>
            )}
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="mt20">
          <Typography className="font-bold fs14">Medication History</Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <div className="flex-row-ali-cen">
            {(apntId || apnt?.petId === getPetData?.[0]?.petId) &&
            medicationList?.length > 0 ? (
              medicationList?.map((ml, i) => (
                <>
                  <div className="w30Per">
                    <div className="flex-column">
                      <Typography className="txt-semi-bold gray7 fs12 mt10">
                        {ml?.name ?? ""}
                      </Typography>
                      {ml?.date ? (
                        <div className="flex-row-ali-cen mt10">
                          <div className="gray-dot2" />
                          <Typography className="txt-semi-bold fs12 ml5 black2">
                            Prescribed Date:{" "}
                            {moment(ml?.date).format("DD MMM YYYY")}
                          </Typography>
                        </div>
                      ) : null}
                    </div>
                  </div>

                  {medicationList?.length !== i + 1 ? (
                    <div className="w5Per">
                      <div className="flex-center">
                        <div className="ver-bar-h30 h50" />
                      </div>
                    </div>
                  ) : null}
                </>
              ))
            ) : (
              <div className="no-rec h50">No records available</div>
            )}
          </div>
        </Grid>
      </Grid>

      <CustomModal
        open={bundleModVsble}
        onClose={handleBundleclose}
        header="Select Bundle"
        modal
        modalWidth={40}
      >
        <div className="scroll-60vh pr10">
          <CustomTextField
            placeholder="Search"
            fullWidth
            handleChange={(e) => setBundleSearchValue(e.target.value)}
            value={bundleSearchValue}
            backgroundColor={AppColors.lightPink}
          />

          {petTreatmentBundles?.length > 0 ? (
            (bundleSearchValue?.length > 0
              ? petTreatmentBundles?.filter((bl) =>
                  bl?.bundleName
                    ?.toLowerCase()
                    ?.includes(bundleSearchValue?.toLowerCase())
                )
              : petTreatmentBundles
            )?.map((li, i) => {
              return (
                <div
                  key={i}
                  className={`mt15 cursor ${
                    li?.bundleId === selectedBundle?.bundleId
                      ? "blue-box2"
                      : "gray-box3"
                  }`}
                  onClick={() => setSelectedBundle(li)}
                >
                  <div className="flex-row-between-align-center">
                    <div className="flex-row-ali-cen">
                      <CustomCheckbox
                        circle
                        checked={
                          selectedBundle
                            ? li?.bundleId === selectedBundle?.bundleId
                            : false
                        }
                      />
                      <Typography className="fs14 blue-color font-bold">
                        {li?.bundleName}
                      </Typography>
                    </div>
                    <Typography className="font-bold fs14 red12">
                      Rs {Number(li?.estimatedCost)?.toFixed(2)}
                    </Typography>
                  </div>
                  <div className="flex-row-ali-cen ph10">
                    <div className="gry-dot2" />
                    <Typography className="fs12 blue-color txt-regular ml5">
                      Type:
                    </Typography>
                    <Typography className="fs12 black20 txt-regular ml5">
                      {li?.usageType}
                    </Typography>
                  </div>

                  <Typography className="gray22 fs14 font-medium ph10">
                    {li?.description}
                  </Typography>
                </div>
              );
            })
          ) : (
            <div className="no-record">No active bundles available</div>
          )}
          {selectedBundle ? (
            <div className="flex-center">
              <div className="mv20">
                <CustomButton smallBtn text="Assign" onClick={handleAssign} />
              </div>
            </div>
          ) : null}
        </div>
      </CustomModal>
    </>
  );
};

export default Overview;
